import { validateEmail } from "./validateEmail";

export const useValidateEmail = (email: string) => {
  if (!validateEmail(email)) {
    return "Please enter a valid email address.";
  }

  return null;
};

export const useValidateSerialHash = () => {
  return (serialHash: string | null) => {
    if (!serialHash) {
      return "No serial hash has been provided.";
    }

    return null;
  };
};
